import { render, staticRenderFns } from "./ricercaGaranzieECommerce.vue?vue&type=template&id=7f6f3b9e&"
import script from "./ricercaGaranzieECommerce.vue.ts?vue&type=script&lang=ts&"
export * from "./ricercaGaranzieECommerce.vue.ts?vue&type=script&lang=ts&"
import style0 from "./ricercaGaranzieECommerce.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports